import React from "react";

function Contact(){
    return(
        <div>
            <h1> KS</h1>
            <p> dsfhasfjdfjdsfjfdshsdfhj </p>
        </div>
    )
}

export default Contact